import { render } from "./TileGameCreate.vue?vue&type=template&id=1814905d"
import script from "./TileGameCreate.vue?vue&type=script&lang=js"
export * from "./TileGameCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__